export default "__VITE_ASSET__Dz2d6OJI__"